module.exports = __webpack_public_path__ + "static/img/12.b448371.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/12.png
// module id = OrhS
// module chunks = 0